"use client";
import { createContext, useContext } from "react";
import { ProductDetailData } from "./productDetail.types";

const ProductDetailInitialContext = createContext<ProductDetailData | null>(null);

export const ProductDetailInitialProvider = ({
  initialData,
  children,
}: {
  initialData: ProductDetailData;
  children: React.ReactNode;
}) => (
  <ProductDetailInitialContext.Provider value={initialData}>
    {children}
  </ProductDetailInitialContext.Provider>
);

export const useProductDetailInitial = () =>
  useContext(ProductDetailInitialContext);